// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__n7ygh","logo":"Navbar_logo__jA5Pb","navLinks":"Navbar_navLinks__UMGgk","active":"Navbar_active__+dvfu","menuToggle":"Navbar_menuToggle__IPiTw"};